import IosShareIcon from '@mui/icons-material/IosShare'
import { Button, ButtonProps, Tooltip } from '@mui/material'
import { FC, useCallback, useContext, useState } from 'react'
import { generatePath } from 'react-router-dom'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppRoutes } from '../../models'
import { RepairOrderContext } from '../../providers/RepairOrderProvider/RepairOrderProvider'
import { useGenerateApiKeyWithIntentMutation } from '../../redux/api/apiKeyApi'
import { useCreateStandaloneApiKeyForCustomerMutation } from '../../redux/api/inspectionApi'
import {
  CustomerEntry,
  GenerateApiKeyWithIntentRequestIntentEnum
} from '../../sdk'
import { ShareViaContainer } from '../SharedUI/ShareViaContainer'
import { IncludePartsStorageKey } from '../SharedUI/ShareViaMainDialog'

interface Props extends ButtonProps {
  customer?: CustomerEntry
}

const ShareCustomerPortalButton: FC<Props> = ({ customer, ...props }) => {
  const { repairOrder, inspections } = useContext(RepairOrderContext)
  const { accessToken } = useAccessTokenAndShopId()
  const [getApiKey] = useGenerateApiKeyWithIntentMutation()
  const [getCustomerInspectionLink] =
    useCreateStandaloneApiKeyForCustomerMutation()

  const [link, setLink] = useState<string>('')

  const generateLink = useCallback(
    async (showPartsLabor: boolean) => {
      let path = ''
      if (inspections && inspections.length === 1) {
        const key = await getCustomerInspectionLink({
          authorization: accessToken,
          createStandaloneApiKeyForCustomerRequest: {
            inspectionId: inspections[0].id!,
            showPrice: true,
            showPartsLabor
          }
        }).unwrap()
        path = generatePath(AppRoutes.INSPECTION_RESULTS, { apiKey: key })
      } else {
        const key = await getApiKey({
          authorization: accessToken,
          generateApiKeyWithIntentRequest: {
            repairOrderId: repairOrder!.entry!.id!,
            intent: GenerateApiKeyWithIntentRequestIntentEnum.Authorization,
            showPartsLabor
          }
        }).unwrap()
        path = generatePath(AppRoutes.CUSTOMER_PORTAL, { apiKey: key })
      }

      setLink(window.location.origin + path)
    },
    [
      accessToken,
      getApiKey,
      repairOrder,
      getCustomerInspectionLink,
      inspections
    ]
  )

  return (
    <>
      {link && (
        <ShareViaContainer
          title={'Digital Authorization'}
          link={link}
          handleClose={() => {
            setLink('')
          }}
          customer={customer}
          regenerateLink={generateLink}
        />
      )}
      <Tooltip title="Share Digital Authorization Link">
        <Button
          variant="text"
          color="primary"
          startIcon={<IosShareIcon />}
          onClick={() =>
            generateLink(
              localStorage.getItem(IncludePartsStorageKey) === 'true'
            )
          }
          {...props}>
          Share Estimate
        </Button>
      </Tooltip>
    </>
  )
}

export default ShareCustomerPortalButton
